import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { Row, Card, CardHeader, CardBody } from "reactstrap";
import Loader from "../../../ui/loader";
import FilesTable from "./files-table";
import generateAction from "../../../../utils/action-helpers";
import { FILE } from "../../../../state/actions";

const Files = () => {
  const { files, loading } = useSelector(state => state.files);
  const { current } = useSelector(state => state.user);
  const dispatch = useDispatch();
  useEffect(() => {
    if (current.role !== "Admin") {
      dispatch(push("/"));
    }
  }, [current.role, dispatch]);
  useEffect(() => {
    dispatch(generateAction(FILE.FETCH));
  }, [dispatch]);
  if (loading || !files) return <Loader />;
  return (
    <Row>
      <div className="col-12">
        <Card className="mt-sm-3">
          <CardHeader className="d-flex align-items-center justify-content-between">
            <Row>
              <div className="col-12 mb-2">
                <h3>Gestión de ficheros</h3>
              </div>
            </Row>
          </CardHeader>
          <CardBody className="pt-0">
            <FilesTable data={files} />
          </CardBody>
        </Card>
      </div>
    </Row>
  );
};

export default Files;
